import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { hasRoleNow, useAuthStatus, useUserStore } from "@/lib/userStore.ts";

export const Route = createFileRoute("/_auth/_isUser")({
  beforeLoad: async ({ location }) => {
    const store = useUserStore.getState();
    if (store.status === "loading" || store.status === "idle") {
      return;
    }

    const isUser = hasRoleNow("USER");
    if (!isUser) {
      if (store.status === "authenticated") {
        throw redirect({
          to: "/forbidden",
          search: { redirect: location.href, required: "USER" },
          replace: true,
        });
      }
    }
  },
  component: IsUserLayout,
});

function IsUserLayout() {
  const status = useAuthStatus();

  if (status === "loading" || status === "idle") {
    return <div className="p-4">Authentifizierung wird geprüft...</div>;
  }
  return <Outlet />;
}
